<button mat-raised-button (click)="exportApplicationData()">Export Application Data</button>
